import { render, staticRenderFns } from "./ProjectChat.vue?vue&type=template&id=b9ad68e6&"
import script from "./ProjectChat.vue?vue&type=script&lang=js&"
export * from "./ProjectChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports